// extracted by mini-css-extract-plugin
module.exports = {"title":"__2Pz1icWt","content":"nATxvhGL"};